import { FunctionComponent } from 'react'
import { LiveEventTransformedHockey } from '@utils/formatters/hockey'
import ToiTeaserComponents from '@components/Teaser/Toi'

interface TeaserSportsTileHockeyProps {
  formattedData: LiveEventTransformedHockey
}

const {
  TileLeftHalf,
  TileLiveStatusTitle,
  TileMiddleInfo,
  TileRightHalf,
  TileScore,
  TileStatusTitle,
  TileTeamLogo,
  TileTeamName,
} = ToiTeaserComponents

const TeaserSportsTileHockey: FunctionComponent<
  TeaserSportsTileHockeyProps
> = ({ formattedData }) => {
  const {
    isLive,
    statusTitle,
    teams,
    isScheduled,
    sdpScheduledAtShort,
    scoreExplanation,
  } = formattedData

  const [homeTeam, awayTeam] = teams && teams.length ? teams : [null, null]

  const isScoreAvailable = !isScheduled
  const hasEnded = !isLive && !isScheduled

  if (!homeTeam || !awayTeam) {
    return null
  }

  const {
    name: homeTeamName,
    logoUrl: homeTeamLogoUrl,
    score: homeTeamScore,
  } = homeTeam

  const {
    name: awayTeamName,
    logoUrl: awayTeamLogoUrl,
    score: awayTeamScore,
  } = awayTeam

  return (
    <>
      <TileLeftHalf>
        {!!homeTeamLogoUrl && (
          <TileTeamLogo url={homeTeamLogoUrl} name={homeTeamName} />
        )}
        <TileTeamName>{homeTeamName}</TileTeamName>
      </TileLeftHalf>
      <TileMiddleInfo>
        {isScoreAvailable && (
          <TileScore>
            {homeTeamScore}:{awayTeamScore}{' '}
            {!!scoreExplanation && scoreExplanation}
          </TileScore>
        )}
        {!hasEnded && !isLive && (
          <TileStatusTitle>{sdpScheduledAtShort}</TileStatusTitle>
        )}
        {!hasEnded && isLive && (
          <TileLiveStatusTitle>{statusTitle}</TileLiveStatusTitle>
        )}
      </TileMiddleInfo>
      <TileRightHalf>
        {!!awayTeamLogoUrl && (
          <TileTeamLogo url={awayTeamLogoUrl} name={awayTeamName} />
        )}
        <TileTeamName>{awayTeamName}</TileTeamName>
      </TileRightHalf>
    </>
  )
}

export default TeaserSportsTileHockey
